import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import CapCandidatureTable from "./CandidatureDocumentTable";
import AddorUpdateCandidatureDocument from "./AddorUpdateDocument";


export default function Index() {
  const naviagte = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
console.log(page,'page')
 

  return (
    <Grid
      p={page ===  3}
      sx={{
        minHeight: "50vh",
        backgroundColor:
           "#fff",
        borderRadius: "8px",
        p:2
      }}
    >
      {page === "candidature-documentlist" && (
        <Grid container >
          <Grid
            item
            md={12}
            sx={{ display: "flex", justifyContent: "flex-end", py:1 }}
          >
            <MauvelousPrimaryButton
              title={"Add Cap Candidature Document"}
              handleClick={() =>
                naviagte(
                  `/${Cookies.get(
                    "mhet_mst_project"
                  )}/cap-candidature-document?page=addcapcandidaturedocument`
                )
              }
            />
          </Grid>
          <Grid item md={12}>
            <CapCandidatureTable />
          </Grid>
        </Grid>
      )}
      {page === "addcapcandidaturedocument" && <AddorUpdateCandidatureDocument />}
      {page === "updatecapcandidaturedocument" && <AddorUpdateCandidatureDocument />}
    </Grid>
  );
}
